import { render, staticRenderFns } from "./_AddTokenInputs.vue?vue&type=template&id=beff862e"
import script from "./_AddTokenInputs.vue?vue&type=script&lang=ts"
export * from "./_AddTokenInputs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports